import React, { useEffect, useMemo } from "react";
import { icons } from "../../../constants";
import "../styles/styles.css";
import "../../../styles/global.css";
import { useTheme } from "../../../utils/ThemeContext";

const Themes = ({
  setIsBarOpen,
  changeThemeInNavbar,
  openThemes,
  setOpenThemes,
  small = false,
  expandableNavbar,
}) => {
  const { theme, setTheme } = useTheme();

  console.log(openThemes, expandableNavbar);

  // isto ponašanje kao Languages: trenutno izabrani ide prvi
  const sortedThemes = useMemo(() => {
    const all = ["light", "dark"];
    return [theme, ...all.filter((t) => t !== theme)];
  }, [theme]);

  // side-effects kao u staroj verziji: body class + localStorage + callback
  useEffect(() => {
    document.body.classList.toggle("dark-theme", theme === "dark");
    localStorage.setItem("theme", theme);
    changeThemeInNavbar?.(theme);
  }, [theme, changeThemeInNavbar]);

  const handleClickTheme = (nextTheme) => {
    setTheme(nextTheme);
    setIsBarOpen?.(false);
    setOpenThemes(false);
  };

  // ikonica za stavku menija u zavisnosti od globalnog (trenutnog) theme-a
  const themeIcon = (item) => {
    if (item === "light")
      return theme === "light" ? icons.light : icons.light_dark;
    return theme === "light" ? icons.dark : icons.dark_dark;
  };

  const Arrow = () => (
    <img
      src={theme === "light" ? icons.arrow_down : icons.arrow_down_dark}
      style={{
        transform: !openThemes ? "rotate(0)" : "rotate(180deg)",
        transition: "transform 0.1s ease",
      }}
      width={20}
      height={20}
      alt="arrow"
    />
  );

  return (
    <div
      className={`flex-direction-row items-center navbar-themes-wrapper ${
        openThemes || expandableNavbar ? "hovered" : ""
      }`}
      onMouseEnter={!small ? () => setOpenThemes(true) : undefined}
      onMouseLeave={!small ? () => setOpenThemes(false) : undefined}
      style={{ height: "58px" }}
    >
      {/* Selektovani theme (kao selected-language u Languages) */}
      <div
        className="flex-direction-row items-center justify-center pointer selected-language"
        onClick={small ? () => setOpenThemes((prev) => !prev) : undefined}
        style={{ height: "44px" }}
      >
        <img
          src={themeIcon(sortedThemes[0])}
          alt={`${sortedThemes[0]}_icon`}
          className="selected-theme-img"
          width={28}
          height={28}
        />
        {/* {small && <Arrow />} */}
      </div>

      {(openThemes || expandableNavbar) && (
        <div
          className="flex-direction-row items-center other-languages-wrapper"
          style={{ height: "44px" }}
        >
          {sortedThemes.slice(1).map((th) => (
            <div
              key={th}
              className="flex-direction-row items-center justify-center pointer other-language"
              onClick={() => handleClickTheme(th)}
            >
              <img src={themeIcon(th)} alt={`${th}_icon`} />
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Themes;
